export default __webpack_public_path__ + "media/zurb/img/about/jon/jon-image3-86fb8568ef8e2d83b23608926a05a7e6.png";